export const siteSettings = {
  name: "Apex Elite Hub",
  link: "https://apexelitehub.live",
  email: "support@apexelitehub.live",
  appLink: "https://app.apexelitehub.live",
};
